export enum IntegrationRoutePaths {
  TASKS = '/integration/tasks',
  SCHEDULER = '/integration/scheduler',
  STATISTICS = '/integration/statistics',
}
